module.exports = []


//////////////////
// WEBPACK FOOTER
// ./src/components/Schedule/Events/events.json
// module id = 73
// module chunks = 0